export default {
    getPagePreloaderIsActive: (state) => {
        return state.pagePreloaderIsActive;
    },
}
